import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import { SearchUserInfoResponse } from "../../../../../domain/repositories/OffBoardingRepository";

//TODO implement
const StartOffBoardingApiImpl = async (noEditable: SearchUserInfoResponse, info: { elegibleForRehire: boolean; companyPropertyReturned: string; companyPropertyNotReturned?: string; terminationPhase: string; terminationType: string; voluntaryTerminationReason?: string; jobDissatisfactionReason?: string; newOtherJobDetailedReason?: string; involuntaryTerminationReason?: string; supportingComment?: string; resignationFile?: File; }): Promise<Either<ExceptionEntity, void>> => {
    throw new Error('Not implemented');
}

export default StartOffBoardingApiImpl;